import { ProductCarousal } from '@commerce-webcomponents/ui-composite';
import { useSession, useTranslation } from '@nextgen-web-framework/all';

export enum AprContainerKey {
  RECOMMENDED_FOR_YOU = 'cart-1',
  YOUR_FAVORITES = 'cart-2',
}

const RecommendedProducts = () => {
  const { isAnonymous } = useSession();
  const t = useTranslation();
  const PAGE_NAME = 'cart';

  const productCarouselPropsData = [
    {
      title: t('product.recommendedProducts.recommendedForYou'),
      aprContainerKey: AprContainerKey.RECOMMENDED_FOR_YOU,
    },
  ];
  if (!isAnonymous()) {
    productCarouselPropsData.push({
      title: t('product.recommendedProducts.yourFavorites'),
      aprContainerKey: AprContainerKey.YOUR_FAVORITES,
    });
  }

  return (
    <>
      {productCarouselPropsData.map((ProductCarouselProps) => (
        <ProductCarousal
          componentType={'product_carousel'}
          products={[]}
          type="vertical"
          pageName={PAGE_NAME}
          slots={4}
          key={ProductCarouselProps.title}
          {...ProductCarouselProps}
        />
      ))}
    </>
  );
};

export { RecommendedProducts };
